import { FC } from 'react';

import GalleryIcon from '@/assets/svg/ui-elements/grid-outline.svg';
import ListViewIcon from '@/assets/svg/ui-elements/list-view.svg';
import { Tabs } from '@/shared/design-system';

import { FundsView } from '../common';

type Props = {
  activeView: FundsView;
  setActiveView: (_view: FundsView) => void;
};

export const FundsViewToggle: FC<Props> = ({ activeView, setActiveView }) => (
  <Tabs.Root value={activeView} onValueChange={(next) => setActiveView(next as FundsView)}>
    <Tabs.List>
      <Tabs.Tab value="list" icon={<ListViewIcon />} label="List" />
      <Tabs.Tab value="gallery" icon={<GalleryIcon />} label="Gallery" />
    </Tabs.List>
  </Tabs.Root>
);
